"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeadSideEffect = void 0;
const react_1 = require("react");
/**
 * client-only component
 */
const HeadSideEffect = (props) => {
    const { headManager, reduceComponentsToState } = props;
    function emitChange() {
        if (headManager && headManager.mountedInstances) {
            const headElements = react_1.Children.toArray(Array.from(headManager.mountedInstances).filter(Boolean));
            headManager.updateHead(reduceComponentsToState(headElements, props));
        }
    }
    (0, react_1.useLayoutEffect)(() => {
        headManager?.mountedInstances?.add(props.children);
        return () => {
            headManager?.mountedInstances?.delete(props.children);
        };
    });
    // We need to call `updateHead` method whenever the `SideEffect` is trigger in all
    // life-cycles: mount, update, unmount. However, if there are multiple `SideEffect`s
    // being rendered, we only trigger the method from the last one.
    // This is ensured by keeping the last unflushed `updateHead` in the `_pendingUpdate`
    // singleton in the layout effect pass, and actually trigger it in the effect pass.
    (0, react_1.useLayoutEffect)(() => {
        if (headManager) {
            headManager._pendingUpdate = emitChange;
        }
        return () => {
            if (headManager) {
                headManager._pendingUpdate = emitChange;
            }
        };
    });
    (0, react_1.useEffect)(() => {
        if (headManager && headManager._pendingUpdate) {
            headManager._pendingUpdate();
            headManager._pendingUpdate = null;
        }
        return () => {
            if (headManager && headManager._pendingUpdate) {
                headManager._pendingUpdate();
                headManager._pendingUpdate = null;
            }
        };
    });
    return null;
};
exports.HeadSideEffect = HeadSideEffect;
